import React, { useContext } from "react"
import LocaleContext from "../../../../../context/LocaleContext"
import translate, { keys } from "../../../../../translation/translator"
import HomeConsultationDescriptionStyle from "./HomeConsultationDescriptionStyle.module.styl"
import Check from "../../../../../assets/images/check.png"

const HomeConsultationDescription = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={HomeConsultationDescriptionStyle.holder}>
      <p className={HomeConsultationDescriptionStyle.special_text}>
        {translate(keys.HOME_CONSULT_DESC_SPEC_OFFER, locale)}
      </p>
      <p className={HomeConsultationDescriptionStyle.title}>
        <span>{translate(keys.HOME_CONSULT_DESC_FREE, locale)}</span>{" "}
        {translate(keys.HOME_CONSULT_DESC_CONSULTATION, locale)} <br />{" "}
        <span>{translate(keys.HOME_CONSULT_DESC_MED_PRO, locale)}</span>
      </p>
      <p className={HomeConsultationDescriptionStyle.description}>
        {translate(keys.HOME_CONSULT_DESC_TEXT, locale)}
      </p>
      <div className={HomeConsultationDescriptionStyle.features_holder}>
        <div className={HomeConsultationDescriptionStyle.feature}>
          <div className={HomeConsultationDescriptionStyle.item}>
            <img src={Check} alt="check" />
            <p>{translate(keys.HOME_CONSULT_DESC_ONEHUND_PRO, locale)}</p>
          </div>
          <div className={HomeConsultationDescriptionStyle.item}>
            <img src={Check} alt="check" />
            <p>{translate(keys.HOME_CONSULT_DESC_NO_SPAM, locale)}</p>
          </div>
        </div>
        <div className={HomeConsultationDescriptionStyle.feature}>
          <div className={HomeConsultationDescriptionStyle.item}>
            <img src={Check} alt="check" />
            <p>{translate(keys.HOME_CONSULT_DESC_ANON, locale)}</p>
          </div>
          <div className={HomeConsultationDescriptionStyle.item}>
            <img src={Check} alt="check" />
            <p>{translate(keys.HOME_CONSULT_DESC_PDF, locale)}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeConsultationDescription
